import React from 'react';
import translate from '../../i18n/translate';

const DAPP_URL    = 'https://sepolia.metha.life/';
const GITHUB_URL  = 'https://github.com/JVMart/metha';
const ZENODO_DOI  = 'https://doi.org/10.5281/zenodo.20038868';
const DVBC_PDF    = './documents/DVBC_Metha_CaseStudy_v1.4.1.pdf';
const WP_EN       = './documents/Metha_Whitepaper_2026_EN.pdf';
const NEWSLETTER_MAILTO = 'mailto:info@metha.life?subject=Subscribe%20to%20Metha%20updates';

const ETHERSCAN_BASE = 'https://sepolia.etherscan.io/address/';
const CROWDSALE = '0x7B96b7e7670C6330b5F4f8b3F46245e4F49FF560';

export default function Footer() {
  return (
    <footer className="lv2-footer">
      <div className="lv2-shell">
        <div className="lv2-footer-grid">
          <div>
            <a href="#top" className="lv2-logo" style={{ marginBottom: 14 }}>
              <img
                className="lv2-logo-img"
                src="/images/logo.png"
                srcSet="/images/logo.png 1x, /images/logo2x.png 2x"
                alt="Metha Biofund"
              />
            </a>
            <p style={{ color: 'var(--bone-dim)', fontSize: 14, maxWidth: '34ch', margin: '8px 0 0' }}>
              {translate('lv2-footer-tagline')}
            </p>
          </div>

          <div>
            <h4>{translate('lv2-footer-h-protocol')}</h4>
            <ul>
              <li><a href={DAPP_URL} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-dapp')}</a></li>
              <li><a href={ETHERSCAN_BASE + CROWDSALE} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-etherscan')}</a></li>
              <li><a href={GITHUB_URL} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-github')}</a></li>
            </ul>
          </div>

          <div>
            <h4>{translate('lv2-footer-h-docs')}</h4>
            <ul>
              <li><a href={DVBC_PDF} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-dvbc')}</a></li>
              <li><a href={ZENODO_DOI} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-zenodo')}</a></li>
              <li><a href={WP_EN} target="_blank" rel="noopener noreferrer">{translate('lv2-footer-link-wp')}</a></li>
            </ul>
          </div>

          <div className="lv2-footer-contact">
            <h4>{translate('lv2-footer-h-contact')}</h4>
            <ul>
              <li style={{ color: 'var(--bone-dim)', fontSize: 13, marginBottom: 4 }}>
                {translate('lv2-footer-contact-email-label')}
              </li>
              <li>
                <a href="mailto:info@metha.life" style={{ fontFamily: 'var(--mono)' }}>
                  info@metha.life
                </a>
              </li>
            </ul>
          </div>

          <div className="lv2-footer-newsletter">
            <h4>{translate('newsletter-title')}</h4>
            <input
              type="email"
              placeholder="email@domain.com"
              aria-label="Newsletter email"
            />
            <a
              className="lv2-btn lv2-btn-prim"
              href={NEWSLETTER_MAILTO}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              {translate('lv2-footer-subscribe')}
            </a>
          </div>
        </div>

        <div className="lv2-footer-bottom">
          <span>{translate('lv2-footer-license')}</span>
          <span>{translate('lv2-footer-network')}</span>
        </div>
      </div>
    </footer>
  );
}
